<!--
  role="tablist" belongs on the <ul>, not the wrapper: the wrapper also holds the
  rail div, so a tablist there has a non-tab child (aria-required-children), and the
  <ul>'s implicit list role sat between each role="tab" li and its tablist
  (aria-required-parent). An explicit role on the <ul> also takes it out of the axe
  `list` rule, which its role="tab" children would otherwise fail.
-->
<div class="common-tabs" [class.common-tabs--spacious]="size() === 'spacious'" [class.common-tabs--plain]="variant() === 'plain'" [class.common-tabs--no-divider]="!divider()">
    <ul class="common-tabs__list" role="tablist">
        @for (tab of visibleTabs(); track tab.label) {
            @if (isRouterMode()) {
                <li
                    class="tab-item"
                    role="tab"
                    [class.tab-item--disabled]="tab.disabled"
                    [attr.aria-disabled]="tab.disabled ? true : null"
                    [attr.aria-selected]="false"
                    [routerLink]="tab.disabled ? null : tab.route"
                    [queryParams]="tab.disabled ? null : tab.queryParams ?? null"
                    routerLinkActive="tab-item--active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    (click)="onTabClick(tab)"
                >
                    <span class="tab-item__label" translate>{{ tab.label }}</span>
                    @if (tab.counter !== undefined) {
                        <span class="tab-item__counter">{{ tab.counter }}</span>
                    }
                </li>
            } @else {
                <li
                    class="tab-item"
                    role="tab"
                    [class.tab-item--active]="tab.value === activeValue()"
                    [class.tab-item--disabled]="tab.disabled"
                    [attr.aria-disabled]="tab.disabled ? true : null"
                    [attr.aria-selected]="tab.value === activeValue()"
                    (click)="onTabClick(tab)"
                >
                    <span class="tab-item__label" translate>{{ tab.label }}</span>
                    @if (tab.counter !== undefined) {
                        <span class="tab-item__counter">{{ tab.counter }}</span>
                    }
                </li>
            }
        }
    </ul>
    <div class="common-tabs__rail" aria-hidden="true"></div>
</div>
